<span class="material-icons-outlined dialog-close-icon" (click)='onCloseClick()'>close</span>

@if (data.tripPackage) {
  <h1 mat-dialog-title>{{ data.tripPackage.description }}</h1>
}

<mat-dialog-content>
  <div class="fx-row fx-wrap fx-justify-start fx-items-start fx-xs-column" style="gap: 8px">
    @if (data.tripPackage.master_image) {
      <div class="trip_package_img">
        <img class="package-img" [src]='appService.getBaseServerAddressRoot() + "/document_files/resize/224x157/" + data.tripPackage.master_image' />
      </div>
    }
    <div class="trip_package_data fx-column fx-flex-1-1-0" style="gap: 8px">
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{'Codice' | translate}}:</div>
        <div class="fx-flex-1-1-0">{{ data.tripPackage.code }}</div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{'Stato' | translate}}:</div>
        <div [ngClass]="data.tripPackage.active_status ? 'enabled' : 'disabled'" class="package_status fx-flex-1-1-0">
          <span>{{ data.tripPackage.active_status ? 'Attivo' : 'Non attivo' }}</span>
        </div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{'Destinazioni' | translate}}:</div>
        <div class="fx-flex-1-1-0">
          @for (destination of data.tripPackage.destinations; track destination; let isLast = $last) {
            <span>{{ destination.description }}{{isLast ? '' : ', '}}</span>
          }
        </div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{'Traduzioni Attive' | translate}}:</div>
        <div class="fx-flex-1-1-0">
          @for (lang of data.tripPackage.active_language_codes; track lang) {
            <img class="flag-icon" [src]="'assets/images/flags/4x3/' + lang + '.svg'" />
          }
        </div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{'Prezzo' | translate}}:</div>
        <div class="fx-flex-1-1-0">{{ data.tripPackage.properties.price.value | currency:"EUR" }}</div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{ data.tripPackage.properties.adult_to.name | translate}}:</div>
        <div class="fx-flex-1-1-0">{{ data.tripPackage.properties.adult_to.value }}</div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{data.tripPackage.properties.child_from.name | translate}}:</div>
        <div class="fx-flex-1-1-0">{{ data.tripPackage.properties.child_from.value  }}</div>
      </div>
      <div class="row fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <div class="fx-flex-1-1-0">{{data.tripPackage.properties.child_to.name | translate}}:</div>
        <div class="fx-flex-1-1-0">{{ data.tripPackage.properties.child_to.value  }}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="fx-row fx-justify-end fx-items-center">
  <span (click)="navigateToPackageDetail()" class="trip_package_detail fx-row fx-justify-start fx-items-center">
    {{'Vai al dettaglio pacchetto' | translate}} <span class="material-icons-outlined">arrow_forward_ios</span>
  </span>
</mat-dialog-actions>